import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "OCR", -1)
const _hoisted_2 = { class: "row mt-3 mb-3" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Dra din bild till rutan nedanför för att påbörja OCR-inläsning.", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-10" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Resultat av OCR-inläsning:")
  ])
], -1)
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-md-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_upload = _resolveComponent("image-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_image_upload, {
          accept: "image/jpeg",
          onFileAdded: _cache[0] || (_cache[0] = (file) => _ctx.imageAdded(file)),
          onFileRemoved: _cache[1] || (_cache[1] = () => _ctx.imageRemoved(_ctx.picture.id))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "btn btn-sm btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scan())),
          disabled: _ctx.hasErrors || _ctx.state.submitInProgress
        }, " Läs text ", 8, _hoisted_7)
      ]),
      (_ctx.state.submitInProgress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.state.submitMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", null, _toDisplayString(_ctx.state.result), 1)
          ])
        ])
      ])
    ])
  ]))
}